import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAmenities } from "../amenitiesModal";

export const getAllAmenities = createAsyncThunk(
  "Amenities/FindAllAmenities",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/FindAllAmenities`,
        {
          CustomerName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Amenities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createAmenities = createAsyncThunk(
  "Amenities/InsertAmenities",
  async (AmenitiesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/InsertAmenities`,
        AmenitiesData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Amenities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateAmenities = createAsyncThunk(
  "Amenities/UpdateAmenities",
  async (AmenitiesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/UpdateAmenities`,
        AmenitiesData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Amenities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteAmenities = createAsyncThunk(
  "Amenities/DeleteAmenities",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/DeleteAmenities`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Amenities :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAmenitiesByID = createAsyncThunk(
  "Amenities/FindByIDAmenities",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/FindByIDAmenities`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Image: result.Image,
        Description: result.Description,
        SequenceNo: result.SequenceNo,
        IsActive: result.IsActive ? 1 : 2,
      } as IAmenities;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveAmenities = createAsyncThunk(
  "Amenities/FindAllActiveAmenities",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Amenities/FindAllActiveAmenities`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveAmenities = createAsyncThunk(
  "Amenities/ActiveInActiveAmenities",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/ActiveInActiveAmenities`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Amenities :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const AmenitiesImageUpload = createAsyncThunk(
  "Amenities/AmenitiesImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Amenities/AmenitiesImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Amenities Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
